import { Suspense } from "react";

import { useAuth } from "@/hooks/use-auth";

import { Button } from "../ui/button";
import { Skeleton } from "../ui/skeleton";
import { WalletBalance } from "./balance";
import { useCompanyQuery } from "./hooks/queries/use-company-query";
import { useRechargeDialogStore } from "./hooks/stores/use-recharge-dialog";

export type WalletProps = {
  children: React.ReactNode | React.ReactNode[];
};

export function Wallet(props: WalletProps) {
  const { isMaster, companyId } = useAuth();

  if (isMaster()) {
    return null;
  }

  if (!companyId) {
    return <Skeleton className="rounded-xl p-4 h-[122px]" />;
  }

  return (
    <Suspense fallback={<Skeleton className="rounded-xl p-4 h-[122px]" />}>
      <InternalWallet companyId={companyId} {...props} />
    </Suspense>
  );
}

export function InternalWallet(
  props: WalletProps & {
    companyId: string;
  },
) {
  const { data } = useCompanyQuery(props.companyId);

  if (!data.isPrepaid) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-muted/40 border p-4 rounded-xl">
      {props.children}
    </div>
  );
}

export type WalletTitleProps = {
  children: React.ReactNode | string;
};

export function WalletTitle(props: WalletTitleProps) {
  return <div className="font-medium text-xs text-primary" {...props} />;
}

export function WalletRechargeButton() {
  const { open } = useRechargeDialogStore();

  return (
    <Button className="w-full mt-2" size="sm" onClick={open}>
      Recarregar
    </Button>
  );
}

export { WalletBalance };
